module.exports = "https://cdn.realtymogul.com/static/media/social_ig_blue.9f33c42e.svg";